import React from 'react'
import withGraphQL from '@orionx-dev/react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import withRouter from 'App/helpers/withRouter'
import get from 'lodash/get'

@withGraphQL(
  gql`
    query getMe {
      me {
        _id
      }
    }
  `
)
@withRouter
export default class TermsVerifier extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    me: PropTypes.object,
    children: PropTypes.node,
    location: PropTypes.object
  }

  componentDidUpdate() {
    this.checkQuery()
  }
  checkQuery() {
    const refId = get(this.props, 'location.query.ref')
    if (!refId) return
    if (localStorage.getItem('refId')) this.props.router.push('/')
    localStorage.setItem('refId', refId)
    this.props.router.push('/')
  }
  render() {
    if (!this.props.me) return this.props.children
    this.checkQuery()
    return this.props.children
  }
}
